import { axiosInstance } from "../axiosInstance";

export const getAllBookings = async () => {
  const instance = await axiosInstance();
  return await instance.get("/booking/all");
};
